import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

export default function ConfigCondominioPage() {
  const { cid } = useParams();
  const [form, setForm] = useState({ nombre: '', direccion: '', contactoEmail: '' });
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .get(`/gastos-comunes/condominios/${cid}`)
      .then((r) => {
        const d = r.data;
        setForm({
          nombre: d.nombre || '',
          direccion: d.direccion || '',
          contactoEmail: d.contactoEmail || ''
        });
      })
      .catch((e) => setError(e.response?.data?.error || e.message));
  }, [cid]);

  const save = async (e) => {
    e.preventDefault();
    setError('');
    setMsg('');
    try {
      await api.patch(`/gastos-comunes/condominios/${cid}`, form);
      setMsg('Condominio actualizado.');
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  return (
    <>
      <div className="page-header">
        <h2>Configuración del condominio</h2>
      </div>
      <div className="card">
        {error && <div className="alert alert-error">{error}</div>}
        {msg && <div className="alert alert-success">{msg}</div>}
        <form onSubmit={save}>
          <div className="field">
            <label>Nombre</label>
            <input value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} required />
          </div>
          <div className="field">
            <label>Dirección</label>
            <input value={form.direccion} onChange={(e) => setForm({ ...form, direccion: e.target.value })} />
          </div>
          <div className="field">
            <label>Email contacto administración</label>
            <input
              type="email"
              value={form.contactoEmail}
              onChange={(e) => setForm({ ...form, contactoEmail: e.target.value })}
            />
          </div>
          <button type="submit" className="btn">
            Guardar
          </button>
        </form>
      </div>
    </>
  );
}
